const get = (state) => (/* props */) => state.event

export default { get }
